import React from 'react';
import { useSelector } from 'react-redux';
import { langSelector } from '../store/langSlice';

export default function CustomButton({
  handelClick,
  value,
  outlined=false,
  isArabicStyle=true,
  admin=false
}) {
  const lang = useSelector(langSelector);
  return (
    <div
      className={`group rounded-[15px] xss:rounded-[20px] py-3 ${!admin ? 'mb-10' : 'mb-5'} w-full cursor-pointer ${outlined ? 'hover:bg-primary border-2 border-primary' : 'bg-primary hover:bg-primaryDark'}`}
      onClick={handelClick}
    >
      <p className={`font-medium ${!admin ? 'text-xl xss:text-2xl sm:text-3xl' : 'px-14 text-xl'} w-full text-center ${outlined ? 'text-primary group-hover:text-white' : 'text-white'}`} style={isArabicStyle ? {transform: lang === 'ar' ? 'scaleX(-1)' : 'none', direction: lang === 'ar' ? 'rtl' : 'ltr'} : {}}>{value}</p>
    </div>
  );
}
